import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { LOCATION_CHANGE, routerMiddleware } from 'connected-react-router';
import createRootReducer from 'store/reducer';
import rootSaga from 'sagas';
import { history } from 'routes';
import { getUrlParams, updateURLArg } from '../utils/url';
import routerConfig from '../routes/router.config';

let currentOrgId = getUrlParams('orgId');
let currentAccountId = getUrlParams('accountId');
const exportPath = routerConfig.filter((config) => config.path !== '/').map((config) => config.path);

// 页面跳转时若已有商务中心id和账户id，则自动带上，否则home组件那边会自动跳转到登录页
const getQueryMiddleware = (historyConfig) => (storeConfig) => (next) => (action) => {
  if (action.type === LOCATION_CHANGE) {
    const orgId = getUrlParams('orgId');
    const accountId = getUrlParams('accountId');
    if (orgId && accountId) {
      currentOrgId = orgId;
      currentAccountId = accountId;
    } else if (currentOrgId && currentAccountId && !exportPath.includes(window.location.pathname)) {
      updateURLArg({ orgId: currentOrgId, accountId: currentAccountId });
    }
  }

  return next(action);
};

const sagaMiddleware = createSagaMiddleware();
const enhancers: any[] = [];
const middleware = [
  // logger,
  getQueryMiddleware(history),
  routerMiddleware(history),
  sagaMiddleware,
];
// eslint-disable-next-line no-underscore-dangle
const composeEnhancer: typeof compose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  createRootReducer(history),
  {},
  composeEnhancer(applyMiddleware(...middleware), ...enhancers)
);

// We run the root sagas automatically
sagaMiddleware.run(rootSaga);

export default store;
